import React, { Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Header, Footer, Loading } from './components'
import { AppWrapper } from './pages'
import ScrollToTop from './ScrollToTop'
import Routes, { MobileRoutes } from './routes'

function App() {
  return (
    <Router>
      <ScrollToTop>
        <Suspense fallback={<Loading height='100vh' />}>
          <Switch>
            <Route path='/mobile' component={MobileRoutes} />
            <Route
              path='/'
              component={() => (
                <AppWrapper>
                  <Header />
                  <div style={{minHeight: "62.5vh"}}>
                    <Routes />
                  </div>
                  <Footer />
                </AppWrapper>
              )}
            ></Route>
          </Switch>
        </Suspense>
      </ScrollToTop>
    </Router>
  )
}

export default App
